// Normalize AU/local mobile numbers to the API-required international format.
export const normalizePhoneForApi = (number) => {
  if (!number) return '';

  const original = number.toString().trim();
  if (!original) return '';

  if (original.startsWith('+')) {
    return `+${original.slice(1).replace(/\D/g, '')}`;
  }

  const digits = original.replace(/\D/g, '');
  if (!digits) return '';

  if (digits.startsWith('61')) {
    return `+${digits}`;
  }

  if (digits.startsWith('0')) {
    return `+61${digits.slice(1)}`;
  }

  return `+61${digits}`;
};

// Format phone number for display with spaces
export const formatPhoneDisplay = (number, stripLeadingZero = true) => {
  if (!number) return '';

  const original = number.toString().trim();

  // Check if number has international prefix (+61)
  if (original.startsWith('+61')) {
    const localPart = original.substring(3); // Remove +61
    const digits = localPart.replace(/\D/g, '');
    // Remove leading 0 if present (e.g., +610405... -> +61 405...)
    const cleanDigits = digits.startsWith('0') ? digits.substring(1) : digits;
    // Format as +61 XXX XXX XXX (last group may be longer for unusual lengths)
    if (cleanDigits.length <= 3) return `+61 ${cleanDigits}`;
    if (cleanDigits.length <= 6) return `+61 ${cleanDigits.slice(0, 3)} ${cleanDigits.slice(3)}`;
    return `+61 ${cleanDigits.slice(0, 3)} ${cleanDigits.slice(3, 6)} ${cleanDigits.slice(6)}`;
  }

  // Check if number starts with 61 (country code without +)
  if (original.startsWith('61') && original.length > 10) {
    const localPart = original.substring(2);
    const digits = localPart.replace(/\D/g, '');
    const cleanDigits = digits.startsWith('0') ? digits.substring(1) : digits;
    if (cleanDigits.length <= 3) return `+61 ${cleanDigits}`;
    if (cleanDigits.length <= 6) return `+61 ${cleanDigits.slice(0, 3)} ${cleanDigits.slice(3)}`;
    return `+61 ${cleanDigits.slice(0, 3)} ${cleanDigits.slice(3, 6)} ${cleanDigits.slice(6)}`;
  }

  // Local number format
  let digits = original.replace(/\D/g, '');

  // Strip leading 0 if requested (for when +61 prefix is shown separately)
  if (stripLeadingZero && digits.startsWith('0')) {
    digits = digits.substring(1);
  }

  // Format as XXX XXX XXX… (e.g. 10-digit AU numbers: 04xx xxx xxx with leading 0)
  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `${digits.slice(0, 3)} ${digits.slice(3)}`;
  return `${digits.slice(0, 3)} ${digits.slice(3, 6)} ${digits.slice(6)}`;
};
